import React from 'react';

export const cookieHooks = {
  useCookieStates() {
    const [cookieTableHtml, setCookieTableHtml] = React.useState<string>('');
    const [cookieInformationHtml, setCookieInformationHtml] = React.useState<string>('');

    return {
      cookieTableHtml,
      setCookieTableHtml,
      cookieInformationHtml,
      setCookieInformationHtml,
    };
  },

  useCookieModal() {
    return React.useCallback(() => {
      window.cookieConsent?.showCookieConsentSettings();
    }, []);
  },

  useHandleCookieConsentInitialize() {
    const { setCookieTableHtml, setCookieInformationHtml } = cookieHooks.useCookieStates();

    return React.useCallback(() => {
      const cookieTableHtml = window.cookieConsent.getCookieTable();
      const cookieInformationHtml = window.cookieConsent.getCookieInformation();
      setCookieTableHtml(cookieTableHtml ? cookieTableHtml.outerHTML : '');
      setCookieInformationHtml(cookieInformationHtml ? cookieInformationHtml.outerHTML : '');
    }, [setCookieInformationHtml, setCookieTableHtml]);
  },

  useCookieListener(handleCookieConsentInitialize: () => void) {
    const addCookieListener = React.useCallback(
      () => document.addEventListener('CookieConsentInitialize', handleCookieConsentInitialize),
      [handleCookieConsentInitialize],
    );

    const removeCookieListener = React.useCallback(
      () => document.removeEventListener('CookieConsentInitialize', handleCookieConsentInitialize),
      [handleCookieConsentInitialize],
    );

    return { addCookieListener, removeCookieListener };
  },

  useCookieListenerOnMountUnmount(addCookieListener: () => void, removeCookieListener: () => void) {
    React.useEffect(() => {
      addCookieListener();
      return () => {
        removeCookieListener();
      };
    }, [addCookieListener, removeCookieListener]);
  },
};
